<template>
  <div class="content Tabs">

     <b-tabs card >

          <b-tab :title="lang.tab_NewPhysical"  :title-link-class="textColors" :title-item-class="textColors" active >
            <b-container class="bv-example-row">
             <p>{{lang.infotext_1}}: {{selectedGenericPart}}</p>

             <FormPhysicalComponent :lang="lang.FormPhysical" :source="source"></FormPhysicalComponent>
           
            </b-container>
          </b-tab>
          
         

        </b-tabs>
       

  </div>

</template>
<script>
import { mapGetters } from 'vuex'



import FormPhysicalComponent from '@/components/shared/FormPhysicalComponent'


export default {
  name: "Content",
  components: {
    FormPhysicalComponent,


  },
  props:{
    lang: Object,

  },
  data () {
    return {
      
      
    }
  },
  computed: {
    ...mapGetters({
      

    }),
    
    
    selectedGenericPart(){
      let pm = "";  
      for (let prop in this.$store.getters.selectedRows[0]){
        
        if (this.$store.getters.selectedRows[0][prop].type == "part number"){
          pm = this.$store.getters.selectedRows[0][prop].value.display;
          break;
        }
      }    

      return pm;
    },
    
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        
        
        return "light";
      }else{
        
        return "dark";
      }
      
    },
    source() {
      return this.$route.query.source
    }
  },
  created () {
    

  },

  updated() {
    
    
    

  },
  watch: {
    
    
  

  },
  methods:{
    
    

  },
  
}
</script>

<style lang="scss">

  .Tabs{
    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }
    .container{
      margin-left: 0px;
    }
    .input-PartNumber{
      max-width: 300px;
    }
    .input-Quantity{
      max-width: 100px;
      display: inline;
    }
    
  }




</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartPhysicals/Middle/Content/Content.vue